var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiagonalLinesRect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 396 79"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diagonal-lines-rect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 367",
    fill: "#fff",
    stroke: "#690",
    strokeWidth: 0.5,
    d: "M0 0h79v396H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 71",
    transform: "rotate(90 198 198)",
    clipPath: "url(#diagonal-lines-rect_svg__a)",
    fill: "none",
    stroke: "#690"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3411",
    d: "M119.41 792.3L-334.681-26.938",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3412",
    d: "M124.087 789.709l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3413",
    d: "M128.762 787.117l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3414",
    d: "M133.438 784.526l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3415",
    d: "M138.113 781.934L-315.98-37.306",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3416",
    d: "M142.789 779.342l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3417",
    d: "M147.464 776.75L-306.63-42.488",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3418",
    d: "M152.14 774.159l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3419",
    d: "M156.815 771.568l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3420",
    d: "M161.49 768.976l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3421",
    d: "M166.166 766.384l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3422",
    d: "M170.842 763.792l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3423",
    d: "M175.517 761.2L-278.576-58.038",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3424",
    d: "M180.193 758.609L-273.9-60.631",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3425",
    d: "M184.868 756.017l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3426",
    d: "M189.544 753.425L-264.55-65.815",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3427",
    d: "M194.219 750.834l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3428",
    d: "M198.895 748.242l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3429",
    d: "M203.57 745.65L-250.521-73.588",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3430",
    d: "M208.246 743.059l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3431",
    d: "M212.922 740.467l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3432",
    d: "M217.597 737.876l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3433",
    d: "M222.273 735.284L-231.82-83.956",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3434",
    d: "M226.948 732.692l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3435",
    d: "M231.624 730.1L-222.47-89.138",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3436",
    d: "M236.299 727.509l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3437",
    d: "M240.974 724.917L-213.12-94.323",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3438",
    d: "M245.65 722.325l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3439",
    d: "M250.325 719.734l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3440",
    d: "M255 717.142l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3441",
    d: "M259.676 714.55l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3442",
    d: "M264.352 711.959l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3443",
    d: "M269.028 709.367l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3444",
    d: "M273.703 706.775l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3445",
    d: "M278.379 704.184l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3446",
    d: "M283.054 701.592l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3447",
    d: "M287.73 699l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3448",
    d: "M292.405 696.409l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3449",
    d: "M297.08 693.817l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3450",
    d: "M301.756 691.225l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3451",
    d: "M306.432 688.634l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3452",
    d: "M311.107 686.042l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3453",
    d: "M315.783 683.45L-138.31-135.79",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3454",
    d: "M320.458 680.859l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3455",
    d: "M325.134 678.267l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3456",
    d: "M329.809 675.675l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3457",
    d: "M334.485 673.084l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3458",
    d: "M339.16 670.492l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3459",
    d: "M343.836 667.9l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3460",
    d: "M348.51 665.309l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3461",
    d: "M353.187 662.717l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3462",
    d: "M357.863 660.125L-96.23-159.115",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3463",
    d: "M362.538 657.533l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3464",
    d: "M367.214 654.942L-86.88-164.298",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3465",
    d: "M371.889 652.35L-82.204-166.89",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3466",
    d: "M376.565 649.758l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3467",
    d: "M381.24 647.167l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3468",
    d: "M385.916 644.575l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3469",
    d: "M390.59 641.984l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3470",
    d: "M395.266 639.392l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3471",
    d: "M399.942 636.8L-54.151-182.44",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3472",
    d: "M404.617 634.208l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3473",
    d: "M409.293 631.617L-44.8-187.623",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3474",
    d: "M413.969 629.025l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3475",
    d: "M418.644 626.433L-35.45-192.807",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3476",
    d: "M423.32 623.84L-30.773-195.398",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3477",
    d: "M427.995 621.25L-26.098-197.99",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3478",
    d: "M432.67 618.658l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3479",
    d: "M437.346 616.067l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3480",
    d: "M442.022 613.475l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3481",
    d: "M446.697 610.883L-7.396-208.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3482",
    d: "M451.373 608.29L-2.72-210.948",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3483",
    d: "M456.048 605.7L1.955-213.54",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3484",
    d: "M460.724 603.108L6.63-216.132",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3485",
    d: "M465.399 600.517L11.306-218.723",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3486",
    d: "M470.075 597.925L15.982-221.315",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3487",
    d: "M474.75 595.333L20.657-223.907",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3488",
    d: "M479.426 592.74L25.333-226.498",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3489",
    d: "M484.102 590.15L30.009-229.09",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3490",
    d: "M488.777 587.558L34.684-231.682",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3491",
    d: "M493.452 584.967L39.359-234.273",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3492",
    d: "M498.128 582.375L44.035-236.865",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3493",
    d: "M502.804 579.783L48.71-239.457",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3494",
    d: "M507.479 577.19L53.386-242.048",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3495",
    d: "M512.155 574.599L58.062-244.641",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3496",
    d: "M516.83 572.008L62.737-247.232",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3497",
    d: "M521.506 569.416L67.413-249.824",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3498",
    d: "M526.18 566.825L72.089-252.415",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3499",
    d: "M530.857 564.233L76.764-255.007",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3500",
    d: "M535.533 561.64L81.44-257.598",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3501",
    d: "M540.208 559.05L86.115-260.19",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3502",
    d: "M544.883 556.458L90.79-262.782",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3503",
    d: "M549.558 553.866L95.465-265.374",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3504",
    d: "M554.234 551.275L100.14-267.965",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3505",
    d: "M558.91 548.683l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3506",
    d: "M563.585 546.09L109.492-273.148",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3507",
    d: "M568.26 543.499l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3508",
    d: "M572.936 540.908l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3509",
    d: "M577.612 538.316l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3510",
    d: "M582.287 535.724l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3511",
    d: "M586.963 533.133L132.87-286.107",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3512",
    d: "M591.639 530.54L137.546-288.698",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3513",
    d: "M596.314 527.949L142.22-291.291",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3514",
    d: "M600.99 525.358l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3515",
    d: "M605.665 522.766l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3516",
    d: "M610.34 520.174l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3517",
    d: "M615.016 517.583l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3518",
    d: "M619.69 514.99L165.599-304.248",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3519",
    d: "M624.367 512.4L170.274-306.84",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3520",
    d: "M629.043 509.807L174.95-309.433",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3521",
    d: "M633.718 507.216l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3522",
    d: "M638.394 504.624L184.3-314.616",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3523",
    d: "M643.069 502.032l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3524",
    d: "M647.745 499.44L193.652-319.798",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3525",
    d: "M652.42 496.849l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3526",
    d: "M657.096 494.258l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3527",
    d: "M661.77 491.666l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3528",
    d: "M666.447 489.074l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3529",
    d: "M671.122 486.482l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3530",
    d: "M675.798 483.89L221.705-335.348",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3531",
    d: "M680.474 481.299L226.38-337.941",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3532",
    d: "M685.149 478.708l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3533",
    d: "M689.825 476.115l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3534",
    d: "M694.5 473.524l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3535",
    d: "M699.176 470.932l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3536",
    d: "M703.85 468.34L249.759-350.898",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3537",
    d: "M708.526 465.749l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3538",
    d: "M713.202 463.157l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3539",
    d: "M717.877 460.566l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3540",
    d: "M722.553 457.974L268.46-361.266",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3541",
    d: "M727.228 455.383l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3542",
    d: "M731.904 452.79L277.81-366.45",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3543",
    d: "M736.579 450.199l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3544",
    d: "M741.255 447.607l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3545",
    d: "M745.93 445.016l-454.092-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3546",
    d: "M750.606 442.424l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3547",
    d: "M755.282 439.832l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3548",
    d: "M759.957 437.24L305.864-382",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3549",
    d: "M764.632 434.649l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3550",
    d: "M769.308 432.057l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3551",
    d: "M773.984 429.466L319.89-389.774",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3552",
    d: "M778.659 426.874l-454.093-819.24",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3553",
    d: "M783.335 424.282l-454.093-819.24",
    strokeWidth: 1.00042
  }))));
}

export default __webpack_public_path__ + "909ce3d437e5f740998c346dbffec065.svg";
export { SvgDiagonalLinesRect as ReactComponent };